<div class="direct-link">
  <a *ngIf="!item?.use_button" [routerLink]="_url">{{
    item?.translation_key || item?.text
      | translation
      | translationFromString
      | transformText : item?.text_transform
  }}</a>
  <a pButton *ngIf="item?.use_button" [routerLink]="_url">
    {{
      item?.translation_key || item?.text
        | translation
        | translationFromString
        | transformText : item?.text_transform
    }}
  </a>
</div>
